const initialState = {
  password: '',
  confirmPassword: ''
};

const ResetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default ResetPasswordReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/ResetPasswordReducer.js
 **/